<template>
  <div class="mt-5">
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text"
                  >Refresh<span v-if="isLoading">ing</span></span
                >
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div
              v-if="messageLogs.docs && messageLogs.docs.length > 0"
              class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
            >
              <table class="min-w-full">
                <thead>
                  <tr class="hidden md:table-row">
                    <th
                      class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Subscriber Id
                    </th>
                    <th
                      class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Message Status
                    </th>
                    <th
                      class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Message Type
                    </th>

                    <th
                      class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      DATE
                    </th>

                    <th
                      class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Message
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                  <tr
                    class="grid grid-cols-2 grid-flow-row md:table-row"
                    v-for="log in messageLogs.docs"
                    :key="log.id"
                  >
                    <td
                      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                    >
                      {{ log.subscriberId }}
                    </td>
                    <td
                      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                    >
                      {{ log.messageStatus }}
                    </td>
                    <td
                      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                    >
                      {{ log.type }}
                    </td>

                    <td
                      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                    >
                      {{ log.createdAt | dateFilter }}
                    </td>
                    <td
                      class="px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap w-96"
                    >
                      <NotificationPreview
                        :title="log.title"
                        :description="log.description"
                        :hideAction="true"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <Pagination :page="messageLogs" @pageChanged="loadPage" />
            </div>
            <div
              class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
              v-if="
                !isLoading && messageLogs.docs && messageLogs.docs.length === 0
              "
            >
              You don't have any message logs right now. We will be listing them
              here as soon as we sent a message.
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../../components/Common/Page.vue";
import NotificationPreview from "../../components/Common/NotificationPreview.vue";

import { format } from "date-fns";

import Pagination from "../../components/Common/Pagination";

export default {
  name: "MessageLogs",
  components: {
    Page,
    Pagination,
    NotificationPreview
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  data() {
    return {
      pageTitle: "Message Logs",
      messageLogs: {},
      isLoading: false
    };
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      this.$store.dispatch("getMessageLog", { page }).then(response => {
        this.messageLogs = response.logs;
      });
    },
    refreshCurrentPage() {
      const page = this.messageLogs.page;
      this.loadPage(page);
    }
  }
};
</script>

<style lang="scss" scoped></style>
